import { render } from "./index.vue?vue&type=template&id=84713278&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=84713278&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84713278"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSpinner,QInput,QIcon});
